<template>
  <div style="height: 100%">
    <zj-layout-container>
      <zj-layout-header style="padding: 0rem 0px 0px 0px">
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
      </zj-layout-header>
      <zj-layout-main style="padding: 0rem 0px 0px 0px">
        <el-table
          class="table-default"
          height="100%"
          :data="tableData"
          ref="multipleTable"
          @selection-change="selectionChange"
          border
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            width="80"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="name"
            label="运输资源名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="address"
            label="地址"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="quantity"
            label="数量"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="contacts"
            label="负责人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="contactNo"
            label="联系电话"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" width="60" align="center">
            <template slot-scope="scope">
              <el-button
                @click="deleteClick(scope.$index, scope.row)"
                type="text"
                size="small"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </zj-layout-main>
    </zj-layout-container>

    <el-dialog v-dialogDrag title="运输资源" :visible.sync="dialogTableVisible">
      <zj-layout-container style="height: 60rem">
        <zj-layout-main style="padding: 0rem 0rem">
          <el-table
            ref="multipleTable"
            :data="DialogtableData"
            @selection-change="handleSelectionChange"
            border
            style="width: 100%"
            height="100%"
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="name"
              label="运输资源名称"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="address"
              label="地址"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="quantity"
              label="数量"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="contacts"
              label="负责人"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="contactNo"
              label="联系电话"
              align="center"
            ></el-table-column>
            <el-table-column
              type="selection"
              width="55"
              align="center"
            ></el-table-column>
          </el-table>
        </zj-layout-main>
        <zj-layout-footer style="text-align: center">
          <el-button @click="onBack()">取消</el-button>
          <el-button @click="onOk()">确定</el-button>
        </zj-layout-footer>
      </zj-layout-container>
    </el-dialog>
  </div>
</template>
<script>
import MyApis from "../../../apis";
import { list } from "@/api/src/emergency_tranresources";
export default {
  name: "ZjComponentTransportDetail",
  controller: "UI",
  action: "ComponentTransportDetail",
  props: {
    PlanTaskId: String,
    TaskSubTypeId: String,
    form:Array
  },
  data() {
    return {
      dialogTableVisible: false,
      multipleSelection: [],
      DialogtableData: [],
      tableData: [], //用来作为receivers
      resouceList: [],
    };
  },
  created: function () {
    let searchInfo = {
      size: 10000,
      current: 1,
    };
    this.showLoading("加载中...");
    list(searchInfo)
      .then((r) => {
        r = r.data.records;
        this.DialogtableData = r;
        this.hideLoading();
      })
      .catch((e) => {
        console.error(e);
        this.hideLoading();
      });
  },
  methods: {
    showLoading(text) {
      this.$emit("loading", text);
    },
    hideLoading() {
      this.$emit("loadingFinish");
    },
    deleteClick(index, row) {
      this.tableData.splice(this.tableData.indexOf(row), 1);
    },
    onAdd() {
      this.dialogTableVisible = true;
      this.$nextTick(() =>{
        this.multipleSelection = this.tableData;
        this.toggleSelection(this.multipleSelection);
      })
    },
    onBack() {
      this.dialogTableVisible = false;
    },
    onOk() {
      this.tableData = this.multipleSelection;
      this.dialogTableVisible = false;
    },
    toggleSelection(rows) {
      this.$refs.multipleTable.clearSelection();
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
      Gettaskreceiver() {
      var receivers = [];
      for (var i = 0; i < this.tableData.length; i++) {
        var item = this.tableData[i]
        let obj = {
          resourceId: item.id,
          resourceType: this.TaskSubTypeId,
          needNum: null
        }
        if(item.editId){
          obj.is = item.editId
          obj.taskId = item.taskId
        }
        receivers.push(obj);
      }
      return receivers;
    },
    setDefaultCheckItems(){
      let { DialogtableData, resouceList } = this,tableData=[]
      console.log(DialogtableData, resouceList)
      if(resouceList.length > 0 && DialogtableData.length > 0 ){
        DialogtableData.map(item =>{
          item.editId = ''
          item.taskId = ''
          resouceList.map(child =>{
            if(item.id == child.resourceId){
              item.editId = child.id
              item.taskId = child.taskId
              tableData.push(item)
            }
          })
        })
      }
      this.DialogtableData = DialogtableData
      this.tableData = tableData
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    'form.resouceList':{
       handler(val, oldVal) {
        if (val) {
          console.log(this.TaskSubTypeId)
          this.resouceList = val.filter(item => item.resourceType == this.TaskSubTypeId)
          this.setDefaultCheckItems();
        }
      },
      deep: true,
      immediate: true,
    },
    'DialogtableData': function (val) {
      this.setDefaultCheckItems();
    },
  },
};
</script>